<header class="geofence-header">
  <div class="header-icon-section">
    <i class="pi pi-map large-icon"></i>
    <div class="header-description">
      <h3 class="area">{{ geofence()?.name }}</h3>
      <div class="area-description">Main Coverage Area</div>
    </div>
  </div>
</header>
